import React from "react";
import RatingScale from "./RatingScale";

const SkillsRating = ({ skills, ratings, handleRatingChange }) => {
  return (
    <div className="p-4 flex flex-col gap-6 divide-y-2 divide-lineGray">
      <h3 className="text-sm font-normal text-dark py-2">
        Lütfen Junior Seviyeye Uygun Puanlama Yapınız.
      </h3>
      {skills.map((skill) => (
        <div
          key={skill._id || skill.name || `skill-${skill.name}`}
          className="flex justify-between pt-6 items-center"
        >
          <p className="text-sm font-medium text-dark">{skill.name}</p>
          <div className="min-w-[388px]">
            <RatingScale
              category={skill.name}
              selected={ratings[skill.name] || null}
              handleRatingChange={handleRatingChange}
              page="anket"
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default SkillsRating;
